export const kycLinkStyles = {
  badgeMuted:
    "inline-flex items-center rounded-full bg-[#F1F5F9] px-2.5 py-[3px] text-[11px] font-semibold tracking-[0.4px] text-[#63738C]",
  badgeSuccess:
    "inline-flex items-center rounded-full bg-[#DCFCE7] px-2.5 py-[3px] text-[11px] font-semibold text-[#166634]",
  badgeExpired:
    "inline-flex items-center rounded-full bg-[#FFEDD5] px-2.5 py-[3px] text-[11px] font-semibold text-[#C25912]",
  badgeInfo:
    "inline-flex items-center rounded-full bg-[#DBEAFE] px-2.5 py-[3px] text-[11px] font-semibold text-[#1D4ED8]",
  panel: "flex flex-col gap-5",
  heading: "flex flex-col gap-2",
  titleRow: "flex flex-wrap items-center gap-2",
  title: "text-lg font-bold text-[#0F172A]",
  subtitle: "text-[13px] leading-5 text-[#64748B]",
  recipients: "flex flex-col gap-3",
  recipientsLabel: "text-[11px] font-semibold tracking-[0.7px] text-[#64748B]",
  contactGrid: "flex flex-wrap gap-x-8 gap-y-3",
  contactCol: "flex min-w-[140px] flex-1 flex-col gap-1.5",
  contactMeta: "inline-flex items-center gap-1.5 text-[11px] font-medium text-[#64748B]",
  contactValue: "text-sm font-semibold text-[#0F172A] break-all",
  validityNote: "inline-flex items-center gap-2 text-xs text-[#64748B]",
  callout: "flex items-stretch gap-3 py-3 pr-3",
  calloutBar: "w-[3px] shrink-0 self-stretch",
  calloutCopy: "flex min-w-0 flex-1 flex-col gap-1",
  calloutTitle: "text-[13px] font-semibold leading-[18px]",
  calloutBody: "text-xs leading-4",
  calloutSuccess: "bg-[#F7FFFA]",
  calloutInfo: "bg-[#F8FAFF]",
  calloutWarn: "bg-[#FFF8F0]",
  textActions: "flex items-center gap-5",
  textAction:
    "inline-flex items-center gap-1.5 text-[13px] font-semibold text-primary disabled:cursor-not-allowed disabled:opacity-60",
  primaryButton:
    "w-full inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-5 py-3.5 text-sm font-semibold text-white shadow-[0_10px_18px_rgba(15,92,242,0.28)] disabled:cursor-not-allowed disabled:opacity-60",
  footerNote: "text-center text-xs text-[#64748B]",
  metaRow: "flex flex-wrap gap-6",
  metaLabel: "text-[10px] font-semibold leading-3 text-[#63738C]",
  metaValue: "text-xs font-medium leading-4 text-[#0F1729]",
};
